import React from 'react';
import { PERMISOS_CONFIG } from './permisos.config';

const chunkArray = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += size) {
    chunked.push(array.slice(i, i + size));
  }
  return chunked;
};

const modulosPorFila = chunkArray(PERMISOS_CONFIG, 4);

const obtenerValorModulo = (permisos, moduloKey) => {
  const value = permisos?.[moduloKey];
  if (typeof value === 'boolean') {
    return value;
  }
  if (value && typeof value === 'object') {
    return Object.values(value).some(Boolean);
  }
  return false;
};

const Permisos = ({ permisos = {}, onChange, onSelectAll }) => {

  const handleToggleModulo = (moduloKey, isChecked) => {
    if (typeof onChange !== 'function') return;
    onChange(prev => ({
      ...prev,
      [moduloKey]: isChecked
    }));
  };

  const handleToggleTodos = (checked) => {
    if (typeof onSelectAll === 'function') {
      onSelectAll(checked);
      return;
    }
    if (typeof onChange === 'function') {
      onChange(prev => {
        const actualizados = { ...prev };
        PERMISOS_CONFIG.forEach(modulo => {
          actualizados[modulo.key] = checked;
        });
        return actualizados;
      });
    }
  };

  const isAllSelected = PERMISOS_CONFIG.every(modulo => obtenerValorModulo(permisos, modulo.key));

  return (
    <div className="mt-4">
      <div className="d-flex align-items-center mb-3">
        <h4><strong>Permisos</strong></h4>
        <div className="form-check ml-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="selectAllPermissions"
            checked={isAllSelected}
            onChange={(e) => handleToggleTodos(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="selectAllPermissions">
            Seleccionar todo
          </label>
        </div>
      </div>

      {modulosPorFila.map((fila, rowIndex) => (
        <div className="row mb-3" key={rowIndex}>
          {fila.map(modulo => {
            const isModuleChecked = obtenerValorModulo(permisos, modulo.key);

            return (
              <div className="col-md-3" key={modulo.key}>
                <div className="border rounded p-2" style={{ backgroundColor: '#f9f9f9' }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <small className="text-muted" style={{ fontWeight: 'bold' }}>{modulo.nombre}</small>
                    <input
                      type="checkbox"
                      checked={isModuleChecked}
                      onChange={(e) => handleToggleModulo(modulo.key, e.target.checked)}
                      title={`Permitir acceso a ${modulo.nombre}`}
                    />
                  </div>
                  <small className="text-muted">Acceso</small>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default Permisos;
